import React from 'react';
import { Link } from 'react-router-dom';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-8">
          <div className="mb-8">
            <Link to="/" className="text-teal-600 hover:text-teal-700 flex items-center gap-2 mb-6">
              ← Back to FestPrep
            </Link>
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
            <p className="text-gray-600 mt-2">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By using FestPrep, you agree to these Terms of Service. If you don't agree, please don't use our service.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Description of Service</h2>
            <p className="mb-4">
              FestPrep helps you create playlists based on artists' predicted setlists. We use data from various sources to predict what songs an artist might play at their next show.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. User Accounts</h2>
            <p className="mb-4">
              You're responsible for your account and all activity under it. Keep your login credentials secure.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Third-Party Services</h2>
            <p className="mb-4">
              FestPrep integrates with Apple Music and Spotify. Your use of these services is subject to their respective terms and conditions.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
            <p className="mb-4">
              All music content belongs to the respective artists and rights holders. We don't claim ownership of any music accessed through our service.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Disclaimer</h2>
            <p className="mb-4">
              Setlist predictions are based on historical data and may not reflect actual performances. FestPrep is provided "as is" without warranties of any kind.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Contact</h2>
            <p className="mb-4">
              Questions? Email us at: hello@festprep.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;